module.exports = __webpack_public_path__ + "static/circuitHero_desktop@1.5x-b6df59ba261247dbbce9e30286ea59dc.svg";